// @flow
import { handleActions } from 'redux-actions';
import type { ActionType } from 'redux-actions';
import types from './types';
import typeof {
    expandQuestion,
    collapseQuestion,
    saveQuestion,
    saveQuestionSuccess,
    saveQuestionError,
} from './actions';

export type State = {
    expanded: ?number,
    saving: ?number,
};

export const init: State = {
    expanded: null,
    saving: null,
};

export default handleActions({
    [types.EXPAND_QUESTION]: (state: State, action: ActionType<expandQuestion>): State => {
        if (action.payload == null) return state;
        return {
            ...state,
            expanded: action.payload,
        };
    },
    [types.COLLAPSE_QUESTION]: (state: State, action: ActionType<collapseQuestion>): State => {
        if (action.payload == null) return state;
        return {
            ...state,
            expanded: action.payload === state.expanded ? null : state.expanded,
        };
    },
    [types.SAVE_QUESTION]: (state: State, action: ActionType<saveQuestion>): State => {
        if (action.meta == null) return state;
        return {
            ...state,
            saving: action.meta.index,
        };
    },
    [types.SAVE_QUESTION_SUCCESS]: (state: State, action: ActionType<saveQuestionSuccess>): State => {
        if (action.payload == null) return state;
        return {
            ...state,
            saving: null,
        };
    },
    [types.SAVE_QUESTION_ERROR]: (state: State, action: ActionType<saveQuestionError>): State => {
        if (action.payload == null) return state;
        return {
            ...state,
            saving: null,
        };
    },
}, init);
